import { z } from "zod";

// ============================================================================
// Core Document Schema
// ============================================================================

export const WorkspaceDocumentSchema = z.object({
  id: z.string().uuid(),
  workspaceId: z.string(),
  documentId: z.string(),
  name: z.string().nullable(),
  description: z.string().nullable(),
  docType: z.string().nullable(),
  isActive: z.boolean(),
  createdBy: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type WorkspaceDocument = z.infer<typeof WorkspaceDocumentSchema>;

// ============================================================================
// API Response Schemas
// ============================================================================

export const ListDocumentsResponseSchema = z.object({
  documents: z.array(WorkspaceDocumentSchema),
  total: z.number(),
});

export const DocumentResponseSchema = z.object({
  document: WorkspaceDocumentSchema,
});

export const DownloadResponseSchema = z.object({
  downloadUrl: z.string(),
});

export const UploadResponseSchema = z.object({
  documents: z.array(WorkspaceDocumentSchema),
  message: z.string(),
});

export const MessageResponseSchema = z.object({
  message: z.string(),
});

export type ListDocumentsResponse = z.infer<typeof ListDocumentsResponseSchema>;
export type DocumentResponse = z.infer<typeof DocumentResponseSchema>;
export type DownloadResponse = z.infer<typeof DownloadResponseSchema>;
export type UploadResponse = z.infer<typeof UploadResponseSchema>;
export type MessageResponse = z.infer<typeof MessageResponseSchema>;

// ============================================================================
// API Request Schemas
// ============================================================================

export const UpdateDocumentRequestSchema = z.object({
  name: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  docType: z.string().nullable().optional(),
  isActive: z.boolean().optional(),
});

export type UpdateDocumentRequest = z.infer<typeof UpdateDocumentRequestSchema>;
